<template>
  <div class="page-content-container">
    <div class="content-header flex-center">
      <div class="content-header-right flex-center">
        <img class="header-right-img" :src="userAvatar" />
        <div class="header-right-info">
          <div class="user-info-text">
            Hey，<span style="color:rgba(0, 0, 0, 0.85)">{{ userName }}</span>
          </div>
          <div class="user-info-text">欢迎来到 极客服务/创作中心</div>
        </div>
      </div>
      <div class="content-header-left flex-center">
        <div class="header-left-item">
          <div class="left-item-title">钱包余额</div>
          <div class="left-item-text">
            <span class="left-item-text-pre">¥</span
            >{{ formatData(balanceData.current_money, 2) }}
          </div>
        </div>
        <div class="header-left-line"></div>
        <div class="header-left-item">
          <div class="left-item-title">累计收入</div>
          <div class="left-item-text">
            <span class="left-item-text-pre">¥</span
            >{{ formatData(balanceData.all_income, 2) }}
          </div>
        </div>
      </div>
    </div>
    <div class="content-my-task" v-loading="myTasksLoading">
      <div class="content-task-title flex-center">
        <img src="@/assets/images/home/icon-task.svg" alt="" />
        <div>我的任务</div>
      </div>
      <div class="my-task-box" v-if="myTasksCount">
        <template v-for="(item, index) in myTasks">
          <div
            class="my-task-item"
            :key="index"
            v-if="item.data && item.data.task_count"
          >
            <div class="task-item-title">{{ item.name }}</div>
            <div class="task-item-time flex-center">
              <img src="@/assets/images/home/icon-time.svg" alt="" />
              <div style="margin-left:6px">
                截止时间：{{ item.data.ddl || "-" }}
              </div>
            </div>
            <div class="task-item-info flex-center">
              <div class="item-info-main flex-center">
                <div class="item-info">
                  <div class="item-info-text">
                    {{ formatData(item.data.task_count) }}
                  </div>
                  <div class="item-info-title">任务</div>
                </div>
                <div class="item-info-line"></div>
                <template v-for="(subData, subIndex) in item.data.data">
                  <div class="item-info" :key="subIndex">
                    <div class="item-info-text">
                      {{ formatData(subData.value) }}
                    </div>
                    <div class="item-info-title">
                      {{ subData.name || subData.title }}
                    </div>
                  </div>
                  <div class="item-info-line" :key="subIndex + 'line'"></div>
                </template>
                <div class="item-info">
                  <div class="item-info-text">
                    <span style="font-size:12px">¥</span>
                    {{ formatData(item.data.amount) }}
                  </div>
                  <div class="item-info-title">金额</div>
                </div>
              </div>
              <div
                class="task-btn"
                v-if="authPermissions.includes(item.permission)"
                @click="handleTaskClick(item.route)"
              >
                详情
              </div>
            </div>
          </div>
        </template>
      </div>
      <div class="content-my-task flex-column-center" v-else>
        <img
          class="content-blank-img"
          src="@/assets/images/home/img-no-data.png"
          alt=""
        />
        <div class="content-blank-text">暂无数据</div>
      </div>
    </div>
    <div class="content-task-square" v-loading="taskSquareLoading">
      <div class="content-task-title flex-center">
        <img src="@/assets/images/home/icon-square.svg" />
        <div>任务广场</div>
      </div>
      <div class="task-square-box" v-if="taskSquareCount">
        <template v-for="(item, index) in taskSquare">
          <div
            class="task-square-item"
            v-if="item.data && item.data.task_count"
            :key="index"
          >
            <div class="flex-center" style="justify-content: space-between;">
              <div class="item-title">{{ item.name }}</div>
              <div
                class="item-detail"
                v-if="authPermissions.includes(item.permission)"
                @click="handleTaskClick(item.route)"
              >
                详情 >
              </div>
            </div>
            <div class="item-content-box flex-center">
              <div class="item-content flex-center">
                <div>
                  <div class="item-content-text">
                    {{ formatData(item.data.task_count) }}
                  </div>
                  <div class="item-content-title">任务</div>
                </div>
                <div class="item-content-line"></div>
              </div>

              <template v-for="(subData, subIndex) in item.data.data">
                <div class="item-content flex-center" :key="subIndex">
                  <div>
                    <div class="item-content-text">
                      {{ formatData(subData.value) }}
                    </div>
                    <div class="item-content-title">
                      {{ subData.name || subData.title || "-" }}
                    </div>
                  </div>
                  <div class="item-content-line" :key="subIndex + 'line'"></div>
                </div>
              </template>
              <div class="item-content flex-center">
                <div>
                  <div class="item-content-text">
                    <span style="font-size:12px">¥</span>
                    {{ formatData(item.data.amount) }}
                  </div>
                  <div class="item-content-title">金额</div>
                </div>
              </div>
            </div>
            <img class="item-icon" :src="imgList[index % 5]" />
          </div>
        </template>
        <div class="task-square-item">
          <div class="flex-center" style="justify-content: space-between;">
            <div class="item-title">邀请老师</div>
            <!-- <div class="item-detail" @click="handleTaskClick(route)">
              详情 >
            </div> -->
          </div>
          <div class="item-content-box">
            <div class="item-content-box-test">邀请其他老师加入</div>
            <div class="item-content-box-test">
              让更多优秀的人在这里发出光芒
            </div>
          </div>
          <img class="item-icon" :src="imgList[4]" />
        </div>
      </div>
      <div class="task-square-box flex-column-center" v-else>
        <img
          class="content-blank-img"
          src="@/assets/images/home/img-no-data.png"
          alt=""
        />
        <div class="content-blank-text">暂无数据</div>
      </div>
    </div>
    <div class="content-prompt">
      <div class="content-prompt-left">
        <div>
          👶
          <span style="padding-left:8px">
            新手上路请先看:
            <span class="prompt-left-blue" @click="openHelp"
              >Jiker · 共创空间 使用指南 >></span
            >
          </span>
        </div>
        <div>
          🙋‍♂️
          <span style="padding-left:8px">
            系统使用过程遇到问题，<span class="prompt-left-border"
              >请扫描右侧找工作人员 -></span
            >
          </span>
        </div>
        <div>
          🍺
          <span style="padding-left:8px">
            还有很多定向邀请的任务，<span class="prompt-left-border"
              >请添加工作人员咨询和认领</span
            >
          </span>
        </div>
        <div>
          👉
          <span style="padding-left:8px">
            更多
            <span class="prompt-left-blue" @click="openHelp"> 帮助信息 >></span>
          </span>
        </div>
      </div>
      <div class="prompt-wx">
        <img class="prompt-wx-img" src="../assets/images/home/wx.png" alt="" />
        <div class="prompt-wx-text">扫一扫，咨询&帮助</div>
      </div>
    </div>
  </div>
</template>

<script type="text/javascript">
import { mapState } from "vuex";
import formatData from "@/utils/number";
import dataService from "@/global/service/data";

export default {
  data() {
    return {
      formatData,
      imgList: [
        require("../assets/images/home/icon-bg(0).svg"),
        require("../assets/images/home/icon-bg(1).svg"),
        require("../assets/images/home/icon-bg(2).svg"),
        require("../assets/images/home/icon-bg(3).svg"),
        require("../assets/images/home/icon-bg(4).svg")
      ],
      balanceData: {},
      myTasksLoading: false,
      myTasksCount: 0,
      myTasks: [
        {
          name: "题目审核",
          permission:
            "question.api.fuwu_admin.skill_question_review_task.questions.index",
          route: "QuestionExamineTask",
          data: {}
        },
        {
          name: "题目质检",
          permission:
            "question.api.fuwu_admin.skill_question_review_task.questions.index",
          route: "QuestionQualityInspectionTask",
          data: {}
        },
        {
          name: "编程题目",
          permission: "coding.api.jiker_fuwu_admin.questions.tasks.index",
          route: "programTaskList",
          data: {}
        },
        {
          name: "题目抽检",
          permission:
            "question.api.fuwu_admin.skill_question_spot_check.tasks.index",
          route: "SpotCheck",
          data: {}
        },
        {
          name: "百科建设",
          permission: "kcell.api.jiker.fuwu_admin.stack_build_tasks.index",
          route: "SkillWikiList",
          data: {}
        },
        {
          name: "专栏文章",
          permission: "column.api.jiker_fuwu.columns.build.index",
          route: "ColumnList",
          data: {}
        }
      ],
      taskSquareLoading: false,
      taskSquareCount: 0,
      taskSquare: [
        {
          name: "技能出题",
          permission: "question.api.fuwu_admin.skill_question_tasks.index",
          route: "QuestionSkillTask",
          data: {}
        },
        {
          name: "项目设计",
          permission: "project.api.fuwu_admin.project_tasks.index",
          route: "ProjectTask",
          data: {}
        },
        {
          name: "挑战设计",
          permission: "challenge_service.api.fuwu_admin.challenge_tasks.index",
          route: "ChallengeTask",
          data: {}
        },
        {
          name: "项目作业",
          permission: "expert_service.api.fuwu_admin.homeworks.index",
          route: "HomeworkProject",
          // 我的任务跳转
          myPermission: "expert_service.api.fuwu_admin.homeworks.evaluate_list",
          myRoute: "HomeworkProjectMy",

          data: {}
        },
        {
          name: "挑战作品",
          permission:
            "expert_service.api.fuwu_admin.v2.expert.challenges.works.index",
          route: "ChallengeWork",
          myPermission:
            "expert_service.api.fuwu_admin.v2.expert.challenges.works.evaluate",
          myRoute: "ChallengeWorkMy",
          data: {}
        },
        {
          name: "翻译与校对",
          permission:
            "question.api.fuwu_admin.skill_question_verify_tasks.index",
          route: "QuestionProofreadTask",
          myPermission:
            "question.api.fuwu_admin.skill_question_verify_tasks.my.index",
          myRoute: "QuestionProofreadMy",
          data: {}
        }
      ]
    };
  },
  computed: {
    ...mapState(["userAvatar", "userName", "authPermissions"])
  },
  mounted() {
    this.getData();
  },
  methods: {
    getData() {
      this.myTasksLoading = true;
      this.taskSquareLoading = true;
      dataService.dataBalance().then(res => {
        this.balanceData = res;
      });
      Promise.all([
        dataService.dataQuestionReview1(),
        dataService.dataQuestionReview2(),
        dataService.dataCodingReview(),
        dataService.dataQuestionCheck(),
        dataService.dataWiki(),
        dataService.dataColumn()
      ])
        .then(res => {
          res.forEach((item, index) => {
            this.myTasks[index].data = item;
            if (item.task_count > 0) {
              this.myTasksCount++;
            }
          });
        })
        .finally(() => {
          this.myTasksLoading = false;
        });
      Promise.all([
        dataService.dataQuestionSkill(),
        dataService.dataProjectCreate(),
        dataService.dataChallengeCreate(),
        dataService.dataHomework(),
        dataService.dataChallengeWork(),
        dataService.dataTranslateQuestion()
      ])
        .then(res => {
          res.forEach((item, index) => {
            this.taskSquare[index].data = item;
            if (item.task_count > 0) {
              this.taskSquareCount++;
            }
            if (item.my_tasks && item.my_tasks.task_count > 0) {
              this.myTasksCount++;
              this.myTasks.push({
                name: this.taskSquare[index].name,
                permission:
                  this.taskSquare[index].myPermission ||
                  this.taskSquare[index].permission,
                route:
                  this.taskSquare[index].myRoute ||
                  this.taskSquare[index].route,
                data: item.my_tasks
              });
            }
          });
        })
        .finally(() => {
          this.taskSquareLoading = false;
        });
    },
    handleTaskClick(route) {
      if (route) {
        this.$router.push({ name: route });
      }
    },
    openHelp() {
      window.open("https://jiker.feishu.cn/docs/doccnfwavjkQSSxrHTb4432imOh");
    }
  }
};
</script>
<style lang="less" scoped>
.flex-center {
  display: flex;
  align-items: center;
}
.flex-column-center {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
}
.content-blank-img {
  width: 98px;
  height: 81px;
  margin-bottom: 16px;
}
.content-blank-text {
  font-size: 14px;
  font-weight: 400;
  color: rgba(0, 0, 0, 0.45);
}
.page-content-container {
  padding-bottom: 56px;
  .page-placeholder {
    height: 16px;
    width: 100%;
    background-color: #f2f3f5;
  }
  .content-prompt {
    width: 100%;
    display: flex;
    height: 232px;
    padding: 72px 32px 32px;
    background-image: url("../assets/images/home/prompt.svg");
    justify-content: space-between;
    .content-prompt-left {
      font-size: 14px;
      font-family: AppleColorEmoji;
      color: rgba(0, 0, 0, 0.85);
      line-height: 32px;
      .prompt-left-blue {
        color: #546b99;
        cursor: pointer;
      }
      .prompt-left-border {
        background-image: url("../assets/images/home/icon-color.svg");
        background-position: bottom;
        background-repeat: no-repeat;
      }
    }
    .prompt-wx {
      text-align: center;
      .prompt-wx-img {
        width: 100px;
        height: 100px;
        object-fit: cover;
        background: #ffffff;
        border-radius: 2px;
        border: 1px solid rgba(0, 0, 0, 0.06);
      }
      .prompt-wx-text {
        margin-top: 4px;
        font-size: 12px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: rgba(0, 0, 0, 0.65);
      }
    }
  }
  .content-header {
    width: 100%;
    height: 120px;
    background: #ffffff;
    border-radius: 2px;
    padding: 24px 32px;
    justify-content: space-between;
    .content-header-left {
      .header-left-line {
        width: 1px;
        height: 40px;
        background: #e9e9e9;
        margin: 0 32px;
      }
      .header-left-item {
        // width: 138px;
        text-align: right;
        .left-item-title {
          font-size: 14px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: rgba(0, 0, 0, 0.45);
          line-height: 22px;
          margin-bottom: 4px;
        }
        .left-item-text {
          font-size: 30px;
          font-family: HelveticaNeue;
          color: rgba(0, 0, 0, 0.85);
          line-height: 38px;
        }
        .left-item-text-pre {
          font-size: 20px;
          margin-right: 8px;
        }
      }
    }
    .content-header-right {
      .header-right-img {
        width: 56px;
        height: 56px;
        border-radius: 50%;
        margin-right: 16px;
      }
      .header-right-info {
        padding-top: 4px;
        .user-info-text {
          font-weight: 400;
          color: rgba(0, 0, 0, 0.65);
          font-size: 16px;
          line-height: 30px;
          font-family: PingFangSC-Regular, PingFang SC;
        }
      }
    }
  }
  .content-task-title {
    div {
      font-size: 16px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: rgba(0, 0, 0, 0.85);
      margin-left: 4px;
    }
  }
  .content-my-task {
    margin: 16px 0;
    width: 100%;
    min-height: 142px;
    background: #ffffff;
    border-radius: 2px;
    padding: 24px;

    .my-task-box {
      display: flex;
      flex-wrap: wrap;
      .my-task-item {
        margin-top: 20px;
        width: 277px;
        height: 156px;
        background: rgba(132, 139, 147, 0.05);
        border-radius: 4px;
        padding: 20px 24px;
        margin-right: 20px;
        .task-item-title {
          font-size: 18px;
          font-family: PingFangSC-Semibold, PingFang SC;
          font-weight: 600;
          color: rgba(0, 0, 0, 0.85);
          line-height: 26px;
        }
        .task-item-time {
          margin: 8px 0;
          font-size: 14px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: rgba(0, 0, 0, 0.45);
          line-height: 22px;
        }
        .task-item-info {
          margin-top: 16px;
          width: 100%;
          justify-content: space-between;
          .task-btn {
            width: 64px;
            height: 32px;
            line-height: 30px;
            background: rgba(255, 255, 255, 0);
            border-radius: 16px;
            border: 1px solid #409eff;
            font-size: 14px;
            font-weight: 500;
            color: #409eff;
            font-family: PingFangSC-Medium, PingFang SC;
            text-align: center;
            cursor: pointer;
            &:hover {
              background-color: #ecf5ff;
            }
          }
          .item-info-main {
            .item-info-line {
              width: 1px;
              height: 35px;
              background: #000000;
              opacity: 0.05;
              margin: 0 8px;
            }
            .item-info {
              .item-info-text {
                font-size: 16px;
                font-family: PingFangSC-Semibold, PingFang SC;
                font-weight: 600;
                color: #409eff;
                line-height: 24px;
              }
              .item-info-title {
                font-size: 12px;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                color: rgba(0, 0, 0, 0.45);
                line-height: 20px;
              }
            }
          }
        }
        &:nth-child(3n) {
          margin-right: 0;
        }
      }
    }
  }
  .content-task-square {
    margin: 16px 0;
    width: 100%;
    background: #ffffff;
    border-radius: 2px;
    min-height: 248px;
    padding: 24px;
    .task-square-box {
      display: flex;
      justify-content: space-between;
      flex-wrap: wrap;
      .task-square-item {
        margin-top: 16px;
        position: relative;
        width: 426px;
        height: 122px;
        background: rgba(78, 125, 173, 0.05);
        border-radius: 4px;
        padding: 20px 24px;
        .item-icon {
          position: absolute;
          right: 0px;
          bottom: 2px;
        }
        .item-content-box {
          margin-top: 12px;
          position: relative;
          .item-content {
            .item-content-title {
              font-size: 12px;
              font-family: PingFangSC-Regular, PingFang SC;
              font-weight: 400;
              color: rgba(0, 0, 0, 0.45);
              line-height: 20px;
            }
            .item-content-text {
              font-size: 16px;
              font-family: PingFangSC-Semibold, PingFang SC;
              font-weight: 600;
              color: #409eff;
              line-height: 24px;
            }
            .item-content-line {
              width: 1px;
              height: 35px;
              background: #000000;
              opacity: 0.05;
              margin: 0 12px;
            }
          }
          .item-content-box-test {
            height: 22px;
            font-size: 14px;
            color: #68718e;
            line-height: 22px;
          }
        }
        .item-detail {
          font-size: 14px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
          color: #409eff;
          line-height: 22px;
          cursor: pointer;
        }
        .item-title {
          font-size: 18px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
          color: rgba(0, 0, 0, 0.85);
          line-height: 26px;
        }
      }
    }
  }
}
</style>
